import { useState } from 'react';

import { Contrato, Rubro } from '@/shared/interfaces';
import RubroClienteInfoModal from './RubroClienteInfoModal';

export type ViewClienteRubroInfoTableCellProps = {
  rubro: Rubro;
  contract: Contrato;
};

const ViewClienteRubroInfoTableCell: React.FC<
  ViewClienteRubroInfoTableCellProps
> = ({ contract, rubro }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* ====== Rubro number ====== */}
      <span
        onClick={() => {
          setIsOpen(true);
        }}
        className="table__link"
      >
        {rubro?.numero_referencia}
      </span>

      {/* ====== Modal ====== */}
      <RubroClienteInfoModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        rubro={rubro}
        contract={contract}
      />
    </>
  );
};

export default ViewClienteRubroInfoTableCell;
